import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import * as moment from "moment";
import "moment/locale/pt-br";

export default class PDFRelatorioVenda extends Component {
  renderMetodoPagamento = (pedido) => {
    if (pedido.metodo_pagamento.tipo === "dinheiro") {
      if (pedido.detalhes_pagamento.troco) {
        return "Dinheiro com troco";
      } else {
        return "Dinheiro sem troco";
      }
    } else if (pedido.metodo_pagamento.tipo === "debito") {
      return `Débito - ${pedido.metodo_pagamento.descricao}`;
    } else if (pedido.metodo_pagamento.tipo === "credito") {
      return `Crédito - ${pedido.metodo_pagamento.descricao}`;
    }
  };
  render() {
    return (
      <Document>
        <Page size="A4" orientation="landscape" style={styles.page}>
          <View style={styles.section}>
            <View>
              <Text
                style={{
                  fontWeight: "bold",
                  fontSize: 18,
                  color: "#701B8C",
                  marginBottom: 10,
                }}
              >
                iFeira - Relatório de Vendas
              </Text>
              {this.props.estabelecimento && (
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    color: "#3D434D",
                    marginBottom: 10,
                  }}
                >
                  Estabelecimento:
                  <Text style={{ fontSize: 16, color: "#701B8C" }}>
                    {"  "}
                    {this.props.estabelecimento}
                  </Text>
                </Text>
              )}
              <View style={{ borderTopWidth: 1 }}>
                <Text
                  style={{
                    fontWeight: "bold",
                    fontSize: 14,
                    marginBottom: 10,
                    marginTop: 10,
                  }}
                >
                  Periodo:
                  <Text style={{ fontSize: 14, color: "#701B8C" }}>
                    {"  "}
                    {this.props.dataInicio
                      ? moment(this.props.dataInicio).format("l")
                      : "-"}
                  </Text>
                  <Text style={{ fontSize: 14, color: "#701B8C" }}>
                    {"   à   "}
                    {this.props.dataFim ? moment(this.props.dataFim).format("l") : "-"}
                  </Text>
                </Text>
              </View>
              {this.props.faturamento ? (
                <View>
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 16,
                      color: "#3D434D",
                      marginBottom: 10,
                    }}
                  >
                    Total de pedidos:
                    <Text style={{ fontSize: 16, color: "#701B8C" }}>
                      {"  "}
                      {this.props?.faturamento?.data?.length}
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 15,
                      color: "#3D434D",
                      marginBottom: 10,
                    }}
                  >
                    Total Geral Faturado:
                    <Text style={{ fontSize: 15, color: "#701B8C" }}>
                      {"  R$ "}
                      {parseFloat(this.props.faturamento.total_faturado)
                        .toFixed(2)
                        .replace(".", ",")}
                    </Text>
                  </Text>
                  {this.props.estabelecimento && (
                    <Text
                      style={{
                        fontWeight: "bold",
                        fontSize: 15,
                        color: "#3D434D",
                        marginBottom: 10,
                      }}
                    >
                      Faturamento Estabelecimento (sem frete):
                      <Text style={{ fontSize: 15, color: "#701B8C" }}>
                        {"  R$ "}
                        {parseFloat(this.props.faturamento.subtotal_faturado)
                          .toFixed(2)
                          .replace(".", ",")}
                      </Text>
                    </Text>
                  )}
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 15,
                      color: "#3D434D",
                      marginBottom: 10,
                    }}
                  >
                    % iFeira:
                    <Text style={{ fontSize: 15, color: "#701B8C" }}>
                      {"  R$ "}
                      {parseFloat(this.props.faturamento.total_ifeira)
                        .toFixed(2)
                        .replace(".", ",")}
                    </Text>
                  </Text>
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 15,
                      color: "#3D434D",
                      marginBottom: 10,
                    }}
                  >
                    Faturamento Fretes:
                    <Text style={{ fontSize: 15, color: "#701B8C" }}>
                      {"  R$ "}
                      {parseFloat(this.props.faturamento.total_fretes)
                        .toFixed(2)
                        .replace(".", ",")}
                    </Text>
                  </Text>
                  {this.props.estabelecimento && (
                    <Text
                      style={{
                        fontWeight: "bold",
                        fontSize: 15,
                        color: "#3D434D",
                        marginBottom: 10,
                      }}
                    >
                      Saldo Final Estabelecimento:
                      <Text style={{ fontSize: 15, color: "#701B8C" }}>
                        {"  R$ "}
                        {parseFloat(this.props.faturamento.total_estabelecimento)
                          .toFixed(2)
                          .replace(".", ",")}
                      </Text>
                    </Text>
                  )}
                </View>
              ) : null}
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Data</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Código pedido</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Estabelecimento</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Meio pagamento</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Total</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Subtotal</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Frete</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Troco</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>
                      %iFeira {!this.props.estabelecimento && "(estimada)"}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>%Estab.</Text>
                  </View>
                </View>
                {this.props.faturamento?.data?.map((pedido, i) => (
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {moment(
                          pedido.agendado ? pedido.dataAgendamento : pedido.createdAt,
                        ).format("l")}{" "}
                        {moment(
                          pedido.agendado ? pedido.dataAgendamento : pedido.createdAt,
                        ).format("LT")}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{pedido.codigo}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {pedido.estabelecimento?.nome_fantasia}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {this.renderMetodoPagamento(pedido)}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        R$ {parseFloat(pedido.valor_total).toFixed(2).replace(".", ",")}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        R${" "}
                        {parseFloat(pedido.detalhes_pagamento.subtotal)
                          .toFixed(2)
                          .replace(".", ",")}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        R${" "}
                        {parseFloat(pedido.detalhes_pagamento.frete)
                          .toFixed(2)
                          .replace(".", ",")}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        R${" "}
                        {parseFloat(pedido.detalhes_pagamento.troco)
                          .toFixed(2)
                          .replace(".", ",")}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>R$ {pedido.total_ifeira}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        R$ {pedido.total_estabelecimento}
                      </Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>
            <Text style={{ fontSize: 12, marginTop: 10 }}>
              {"*Emitido em - "}
              {moment(Date.now()).format("l")} {moment(Date.now()).format("LT")}
            </Text>
          </View>
        </Page>
      </Document>
    );
  }
}

const styles = StyleSheet.create({
  page: {
    paddingBottom: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  container: {
    padding: 20,
    backgroundColor: "#F5F6F8",
    height: "100%",
  },
  title: {
    fontSize: 22,
    color: "#000",
    paddingBottom: 20,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
  },
});
